module.exports = __webpack_public_path__ + "static/img/暂无数据@3x.8e33236.png";


//////////////////
// WEBPACK FOOTER
// ./src/page/hzscb/assets/暂无数据@3x.png
// module id = 290
// module chunks = 379 380